import PropTypes from "prop-types";

import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { useLayoutEffect } from "react";
import Wrapper from "../../helpers/Wrapper";

am5.addLicense("AM5C258896422");


const BulletChart = ({
  chartId,
  chartClass,
  chartData,
  chartLabels,
  chartColorSet,
  height
}) => {
  console.log('chartData: ', chartData);

  useLayoutEffect(() => {
    let root = am5.Root.new(chartId);

    // TO CHANGE COLOR OF THE CHART
    let colorSet;
    if (chartColorSet === undefined) {

      // background: linear - gradient(180deg, #D51F30 0 %, #FF9931 27.8 %, #FFD231 56.8 %, #038673 100 %);

      colorSet = [
        am5.color('#D51F30'),
        am5.color('#FF9931'),
        am5.color('#FFD231'),
        am5.color('#038673'),
        // am5.color(0xfb7116),
        // am5.color(0xf6d32b),
        // am5.color(0xf4fb16),
        // am5.color(0xb4dd1e),
        // am5.color(0x19d228),
      ];
    } else {
      colorSet = chartColorSet
    }

    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([
      am5themes_Animated.new(root)
    ]);

    // Create chart
    // https://www.amcharts.com/docs/v5/charts/xy-chart/
    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        wheelX: "none",
        wheelY: "none",
        arrangeTooltips: false,
        paddingRight: 10,
        paddingLeft: 0,
        paddingBottom: 0
      })
    );


    // Create axes
    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
    let yAxis = chart.yAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "category",

        renderer: am5xy.AxisRendererY.new(root, {})
      })
    );

    yAxis.get('renderer').labels.template.set('visible', false)


    yAxis.data.setAll(chartLabels);

    let xRenderer = am5xy.AxisRendererX.new(root, {});
    xRenderer.grid.template.set("forceHidden", true);


    let xAxis = chart.xAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: xRenderer,
        min: 0,
        max: 100,
        numberFormat: "#.'%'"
      })
    );

    xAxis.get("renderer").labels.template.setAll({
      oversizedBehavior: "truncate", // options: "none"/"wrap"/"fit"
      maxWidth: 150,
      textAlign: "center",
      fontSize: 8,
      fontFamily: "Ubuntu",
      fill: "#757575",
      fontWeight: "400",
    });

    // Add range
    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
    // if (gradient) {


    let series = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        xAxis: xAxis,
        yAxis: yAxis,
        valueXField: "value",
        categoryYField: "category",
        fill: am5.color(0x000000),
        stroke: am5.color(0x000000),
      })
    );


    series.columns.template.setAll({
      cornerRadiusTR: 3,
      cornerRadiusBR: 3,
    });

    series.columns.template.setAll({
      height: am5.percent(25)
    });


    series.bullets.push(function () {
      return am5.Bullet.new(root, {
        locationX: 1,
        sprite: am5.Label.new(root, {
          text: "{valueX}%",
          fill: am5.color(0x000000),
          centerY: am5.p50,
          fontFamily: 'Ubuntu',
          fontSize: 12,
          populateText: true,
          fontWeight: 600
        })
      });
    });

    series.data.setAll(chartData);


    let rangeDataItem = xAxis.makeDataItem({ value: 0, endValue: 100 });
    xAxis.createAxisRange(rangeDataItem);

    rangeDataItem.get("axisFill").setAll({
      visible: true,
      fillOpacity: 1,
    });

    let stops = [];
    for (let i = 0; i < colorSet.length; i++) {
      stops.push({ color: colorSet[i] });
    }

    let linearGradient = am5.LinearGradient.new(root, {
      rotation: 0,
      stops: stops
    });

    rangeDataItem.get("axisFill").set("fillGradient", linearGradient);

    // Add cursor
    // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
    let cursor = chart.set("cursor", am5xy.XYCursor.new(root, {
      behavior: "none"
    })
    );
    cursor.lineY.set("visible", false);
    cursor.lineX.set("visible", false);
    series.appear();

    // Make stuff animate on load
    // https://www.amcharts.com/docs/v5/concepts/animations/
    chart.appear(1000, 100);

    return () => {
      root.dispose();
    };
  }, [chartData, chartLabels])

  return (
    <Wrapper>
      <div id={chartId} className={`section-chart-wrapper ${chartClass}`} style={{
        height: height
      }}></div>
    </Wrapper>
  );
}


BulletChart.propTypes = {
  chartId: PropTypes.string,
  chartClass: PropTypes.string,
  // showLegend: PropTypes.bool,
  // showLabels: PropTypes.bool,
  // showVerticalLabels: PropTypes.bool,
  // showHalfVerticalLabels: PropTypes.bool,
  chartData: PropTypes.array,
  chartLabels: PropTypes.array,
  // showShortVerticalLabels: PropTypes.bool,
  chartColorSet: PropTypes.array,
  // minimumGridDistance: PropTypes.any,
  // percentageTooltip: PropTypes.bool,
};


export default BulletChart;